import React from "react";
import "../styles/loading.css";

type Props = {
  style?: React.CSSProperties;
};

const Loading: React.FC<Props> = ({ style }) => (
  <div id="loading" style={style}>
    <div className="loading-center">
      <div className="loading-center-absolute">
        <div className="object" id="object_one"></div>
        <div className="object" id="object_two"></div>
        <div className="object" id="object_three"></div>
        <div className="object" id="object_four"></div>
      </div>
    </div>
  </div>
);

export default Loading;
